function init() {

    window.addEventListener('resize', updateSlashes);

    updateSlashes();
}

function getTangentOfDegreesOrAdsStandardAngle(input) {
    // Convert the input to a number
    let number = parseFloat(input);
    
    // Check if the input is a valid number
    if (!isNaN(number)) {
        // Convert the number from degrees to radians
        let radians = number * (Math.PI / 180);
        // Return the tangent of the number in degrees
        return Math.tan(radians);
    } else {
        // Return the constant value
        return 0.3566;
    }
}

function updateSlashes() {
	const containers = document.querySelectorAll('.ads-slash-container');

    for(const container of containers){

        function calculateSlashAndUncloak(){
            const angle = container.getAttribute("angle");
            const xPos = Math.ceil(getTangentOfDegreesOrAdsStandardAngle(angle) * container.offsetHeight);

            const clipregion = container.querySelector('.ads-slash-clip');
            if(clipregion){
                clipregion.style.opacity = 1;
                clipregion.style.clipPath = `polygon(-1px -1px, ${xPos+5}px -1px, 5px 100%, -1px 100%)`;
            }
            

            const slash = container.querySelector('.ads-slash');
            if(slash){
                slash.style.opacity = 1;
                const slashExp = `polygon(${xPos}px 0, ${xPos + 22}px 0, 22px 100%, 0 100%)`;
                slash.style.clipPath = slashExp;
            }

            container.classList.remove('u-cloak');

        }

        const image = container.querySelector('img');
        if(image && image.complete){
            calculateSlashAndUncloak();
        } else if(image){
            image.addEventListener('load', calculateSlashAndUncloak);
        } else {
            calculateSlashAndUncloak();
        }

        
    }
}

export {
    init
}